// RIMUOVE BACKDROP DEI MODAL PER EVITARE FREEZE PAGINA
document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("hidden.bs.modal", function (e) {
        // e.target è il modal che si è appena chiuso
        const backdrops = document.querySelectorAll(".modal-backdrop");
        const body = document.body;

        // Rimuove tutti i backdrop
        backdrops.forEach((backdrop) => {
            if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
            }
        });

        // Ripristina il body
        body.classList.remove("modal-open");
        body.style.overflow = "auto";
        body.style.paddingRight = "";
    });
});

// Video Player integrato in CKEditor
document.addEventListener("DOMContentLoaded", () => {
    // Trova tutti gli elementi <oembed>
    const embeds = document.querySelectorAll("oembed[url]");

    embeds.forEach((embed) => {
        const url = embed.getAttribute("url"); // Ottieni l'URL del video
        const videoId = url.split("v=")[1]; // Estrai l'ID del video da YouTube

        // Crea il div con l'iframe richiesto da Plyr
        const wrapper = document.createElement("div");
        wrapper.setAttribute("class", "plyr__video-embed");

        wrapper.innerHTML = `
            <iframe
                src="https://www.youtube.com/embed/${videoId}"
                allowfullscreen
                allowtransparency
                allow="autoplay"
            ></iframe>
        `;

        // Sostituisci l'elemento <oembed> con il wrapper
        embed.replaceWith(wrapper);
    });

    // Inizializza Plyr sui video creati: la libreria si scarica solo se ce n'e' almeno uno
    if (document.querySelector(".plyr__video-embed")) {
        window.loadPlyr().then((Plyr) => {
            const players = new Plyr(".plyr__video-embed", {
                controls: ["play", "progress", "volume", "fullscreen"],
            });
        });
    }
});

// Blocco l'evento prinicpale (<a>) quando apro un tooltip
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
  });
});


/* Toggle hamburger navbar */
$("#hamburger").on("click", function () {
    $(this).toggleClass("is-active");
});

/* Invio e Spazio sui comandi montati su <span> o <div> con role="button" (menu e
   modali dell'header). Il browser genera il click da tastiera solo sui <button> veri:
   senza questo sarebbero raggiungibili col tab ma inerti. */
document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
        return;
    }

    const comando = event.target.closest?.('[role="button"]');
    if (!comando || comando !== event.target) {
        return;
    }

    // i <button> e i link con href li gestisce gia' il browser
    if (comando.tagName === "BUTTON" || (comando.tagName === "A" && comando.hasAttribute("href"))) {
        return;
    }

    event.preventDefault(); // lo Spazio scorrerebbe la pagina, l'Invio invierebbe un form
    comando.click();
});


/* Gestione Avvisi */
$("#close_avviso").on("click", function () {
    $("#avviso").css("display", "none");
    setCookie("avviso", 1, 1);
});

initAvviso();

function initAvviso() {
    var avviso = getCookie("avviso");
    if ($("#avviso").length > 0) {
        if (avviso == 1) {
            $("#avviso").css("display", "none");
        } else {
            $("#avviso").css("display", "block");
        }
    }
}

/* Gestione Popup */
$("#close_popup").on("click", function () {
    $("#popup").css("display", "none");
    setCookie("popup", 1, 1);
});

initPopup();

function initPopup() {
    var popup = getCookie("popup");
    if ($("#popup").length > 0) {
        var modal_popup = new bootstrap.Modal(document.getElementById("popup"));
        if (popup == 1) {
            modal_popup.hide();
        } else {
            modal_popup.show();
        }
    }
}

/* Inizializza Tooltip Bootstrap */
const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

/* Hack per svuotare i form dll'interno dei modal una volta che si ritorna dalla thankyou page */
document.querySelectorAll(".modal").forEach(function (modal) {
    modal.addEventListener("show.bs.modal", function () {
        // Reset del form se si torna indietro nel browser
        if (window.performance.navigation.type === 2) {
            const form = this.querySelector("form");
            if (form) form.reset();
        }
        // Assicurati che il primo elemento interattivo abbia focus
        const focusable = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable) focusable.focus();

        // Rimuovi eventuali backdrop o classi residue
        document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
        document.body.classList.remove('modal-open');
    });
});

/* Funzione Sroll_To Top page */
$('.go-to-top-page').click(function(e) {
    e.preventDefault();
    $("html, body").animate({
        scrollTop: 0
    }, "fast");
    return false;
});


/* Menu brands mobile e ricerca */
$("*[data-open-sub]").click(function () {
    var classe = $(this).attr("data-open-sub");
    var closeother = $(this).attr("data-closeother");
    if ($(this).hasClass("active")) {
        $("." + classe).slideToggle();
        $(".notactive").removeClass("active");
    } else {
        $(this).toggleClass("active");
        $(".notactive").not($(this)).removeClass("active");
        $("." + classe).slideDown("fast");
        $("." + closeother).slideUp("fast");
        $(".closesub")
            .not("." + classe)
            .slideUp("fast");
        $("." + classe).toggleClass("show");
    }
});
